import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Box, Button, Grid } from '@kis-technologies/kis-ui';
import { ForwardNavigationButton } from 'components/ForwardNavigationButton';
import { FooterProps } from '../types';
import { useStyles } from './styled';

/**
 * Footer that is used to navigate through ticketing flow
 */
const Footer: React.FC<FooterProps> = (props: FooterProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const {
    prevText = t('commonText.back'),
    nextText,
    isNextDisabled,
    isPrevDisabled,
    isPrevLoading,
    hideBackButton,
    onPrevClick,
    onNextClick,
    skipNavPrompt,
    children
  } = props;

  const handlePrevClick = () => {
    if (typeof onPrevClick === 'function') onPrevClick();
    if (typeof onPrevClick === 'string') navigate(onPrevClick);
  };

  const handleNextClick = () => {
    if (typeof onNextClick === 'function') onNextClick();
    if (typeof onNextClick === 'string') navigate(onNextClick);
  };

  const classes = useStyles({ hideBackButton })();

  return (
    <Grid container className={classes.footerContainer}>
      {/* Previous Button - Left Side */}
      {!hideBackButton && (
        <Button
          disabled={isPrevDisabled}
          onClick={handlePrevClick}
          appearance="white"
          customSize="x-large"
          startIconName="prev_circle"
          className={classes.footerLeftButton}
          isLoading={isPrevLoading}
        >
          {prevText}
        </Button>
      )}

      {/* If there is children, render it between Buttons */}
      {children && <Box flexOverride="none">{children}</Box>}

      {/* ForwardNavigationButton - Have the capability to show prompt animation or text */}
      <ForwardNavigationButton
        isDisabled={isNextDisabled}
        label={nextText}
        onClick={handleNextClick}
        testId="next-page-button"
        skipNavPrompt={skipNavPrompt}
      />
    </Grid>
  );
};

export default Footer;
